import { type PayloadAction, createSlice } from "@reduxjs/toolkit"

import { logout } from "../../LoginPage/redux/auth.thunks.ts"
import type {
  ColumnConfigItem,
  SurfacePreferences,
  TabKey,
  UIPreferences,
  UserUIPreferencesState
} from "./ui-preferences.types"

const initialState: UserUIPreferencesState = {
  prefs: {},
  surfacePrefs: {},
  loaded: false,
  loading: false,
  error: null
}

const uiPreferencesSlice = createSlice({
  name: "userUIPreferences",
  initialState,
  reducers: {
    setAllPrefs: (state, action: PayloadAction<UIPreferences>) => {
      state.prefs = action.payload
    },
    setTablePrefs: (
      state,
      action: PayloadAction<{
        tableKey: string
        tabKey: TabKey
        columns: ColumnConfigItem[]
      }>
    ) => {
      const { tableKey, tabKey, columns } = action.payload
      state.prefs.tables = state.prefs.tables ?? {}
      state.prefs.tables[tableKey] = state.prefs.tables[tableKey] ?? {}
      state.prefs.tables[tableKey][tabKey] = { columns }
    },
    clearTabPrefs: (
      state,
      action: PayloadAction<{ tableKey: string; tabKey: TabKey }>
    ) => {
      const { tableKey, tabKey } = action.payload
      const tableCfg = state.prefs.tables?.[tableKey]
      if (tableCfg) delete tableCfg[tabKey]
    },
    replaceSurfacePrefs: (state, action: PayloadAction<SurfacePreferences>) => {
      state.surfacePrefs = action.payload
    },
    setSurfacePref: (
      state,
      action: PayloadAction<{ key: string; value: unknown }>
    ) => {
      const { key, value } = action.payload
      state.surfacePrefs = state.surfacePrefs ?? {}
      if (value === null || value === undefined) delete state.surfacePrefs[key]
      else state.surfacePrefs[key] = value
    },
    setPrefsLoaded: (state) => {
      state.loaded = true
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(logout.fulfilled, () => initialState)
  }
})

export const {
  setAllPrefs,
  setTablePrefs,
  clearTabPrefs,
  replaceSurfacePrefs,
  setSurfacePref,
  setPrefsLoaded,
  setLoading,
  setError
} = uiPreferencesSlice.actions

export default uiPreferencesSlice
